import styled from "@emotion/styled";
import { PureComponent } from "react";
import TextareaAutosize from "react-textarea-autosize";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

interface ITextareaWrapperProps {
  privateMode: boolean;
}

const TextareaWrapper = styled.div<ITextareaWrapperProps>`
  textarea {
    background: transparent;
    border: 0;
    color: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => withVar(props.privateMode ? DesignToken.ContentInvertPrimary : DesignToken.ContentBasicPrimary)
    };
    font-size: 15px;
    line-height: 1.47;
    margin: 0;
    outline: none;
    padding: 0;
    resize: none;
    width: 100%;
    white-space: pre-wrap;

    &::placeholder {
      color: ${
        // FIXME: Fix this the next time the file is edited.
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
        (props: any) =>
          withVar(props.privateMode ? DesignToken.ContentInvertDisabled : DesignToken.ContentBasicDisabled)
      };
    }
  }
`;

export interface IProps {
  value: string;
  placeholder: string;
  disabled: boolean;
  mobile: boolean;
  privateMode?: boolean;
  maxRows?: number;
  innerRef?(textarea: HTMLTextAreaElement): void;
  onInput?(e: React.FormEvent<HTMLTextAreaElement>): void;
  onChange?(e: React.FormEvent<HTMLTextAreaElement>): void;
  onKeyDown?(e: React.KeyboardEvent<HTMLElement>): void;
  onFocus?(e: React.FocusEvent<HTMLTextAreaElement>): void;
  onBlur?(e: React.FocusEvent<HTMLTextAreaElement>): void;
  onClick?(e: React.MouseEvent): void;
  onResize?(): void;
}

export class Textarea extends PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      value,
      placeholder,
      disabled,
      mobile,
      privateMode,
      maxRows,
      innerRef,
      onInput,
      onChange,
      onKeyDown,
      onFocus,
      onBlur,
      onResize,
      onClick,
    } = this.props;

    return (
      <TextareaWrapper privateMode={!!privateMode}>
        <TextareaAutosize
          value={value}
          placeholder={placeholder}
          disabled={disabled}
          minRows={mobile ? 1 : 2}
          maxRows={maxRows || 5}
          ref={innerRef}
          onInput={onInput}
          onChange={onChange}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          onBlur={onBlur}
          onHeightChange={onResize}
          onClick={onClick}
        />
      </TextareaWrapper>
    );
  }
}
